import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-users-new-user-new-role',
  templateUrl: './users-new-user-new-role.component.html',
  styleUrls: ['./users-new-user-new-role.component.scss']
})
export class UsersNewUserNewRoleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
